import { Fireworks } from 'fireworks-js';

function initTimeline() {
	const slideUpElements = document.querySelectorAll(
		'.timeline-event__content'
	);

	if (!slideUpElements.length) {
		return;
	}

	slideUpElements.forEach((element) => {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					element.classList.add('active');
				}
			});
		});

		observer.observe(element);
	});

	const container = document.querySelector('.timeline-end');
	const fireworks = new Fireworks(container, {
		autoresize: true,
		opacity: 0.5,
		acceleration: 1.05,
		friction: 0.97,
		gravity: 1.5,
		particles: 50,
		traceLength: 3,
		traceSpeed: 10,
		explosion: 5,
		intensity: 30,
		flickering: 50,
		lineStyle: 'round',
		boundaries: {
			min: 1080,
			max: 1280,
		},
		hue: {
			min: 105,
			max: 250,
		},
		delay: {
			min: 60,
			max: 90,
		},
		rocketsPoint: {
			min: 50,
			max: 50,
		},
		lineWidth: {
			explosion: {
				min: 1,
				max: 3,
			},
			trace: {
				min: 1,
				max: 2,
			},
		},
		brightness: {
			min: 50,
			max: 80,
		},
		decay: {
			min: 0.015,
			max: 0.03,
		},
		mouse: {
			click: false,
			move: false,
			max: 1,
		},
	});

	const timelineGrid = document.querySelector('.timeline-events-grid');
	window.addEventListener('scroll', function () {
		if (
			window.scrollY + window.innerHeight >=
			timelineGrid.offsetHeight + timelineGrid.offsetTop
		) {
			fireworks.start();
		}
	});
}

document.addEventListener('DOMContentLoaded', initTimeline);
